module.exports = __webpack_public_path__ + "img/05.e0b92440.png";